import { render, staticRenderFns } from "./EmailSenderEdit.vue?vue&type=template&id=4a3c7dc6&scoped=true&lang=pug&"
import script from "./EmailSenderEdit.vue?vue&type=script&lang=js&"
export * from "./EmailSenderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3c7dc6",
  null
  
)

export default component.exports